import { USER_LOAN_PROGRAM } from '@/config/constants';

export type RefiType =
  | 'rate_and_term'
  | 'cash_out'
  | 'streamline'
  | 'heloc'
  | 'heloan'
  | 'second_mortgage';

export const REFI_TYPE_LABELS: Record<RefiType, string> = {
  rate_and_term: 'Rate & Term',
  cash_out: 'Cash-Out',
  streamline: 'Streamline',
  heloc: 'HELOC',
  heloan: 'HELOAN',
  second_mortgage: '2nd Mortgage',
};

export const getRefiTypeOptions = (program: USER_LOAN_PROGRAM): RefiType[] => {
  switch (program) {
    case USER_LOAN_PROGRAM.HELOC:
      return ['heloc'];
    case USER_LOAN_PROGRAM.HELOAN:
      return ['heloan'];
    case USER_LOAN_PROGRAM.SECOND_MORTGAGE:
      return ['second_mortgage'];
    case USER_LOAN_PROGRAM.VA:
    case USER_LOAN_PROGRAM.FHA:
      return ['rate_and_term', 'cash_out', 'streamline'];
    default:
      return ['rate_and_term', 'cash_out'];
  }
};

export const normalizeRefiType = (
  program: USER_LOAN_PROGRAM,
  refiType: RefiType
) => {
  const options = getRefiTypeOptions(program);
  return options.includes(refiType) ? refiType : options[0];
};
